import * as React from "react";

export const MovingSvg = () => (
  <svg viewBox="100 100 400 400">
    <g fill="none" fillRule="evenodd">
      <rect width="737" height="491" fill="#fff" fillRule="nonzero" />
      <g transform="translate(-81 -202)">
        <g transform="translate(10 109)" opacity=".07">
          <path
            d="m250.81 252.59c-0.355-0.142-0.739-0.225-1.144-0.225 0.406 0 0.793 0.078 1.148 0.221l-4e-3 4e-3m1.943-4.538v-5e-3 5e-3m0-0.018v-6e-3 6e-3m0-0.02c0-4e-3 -1e-3 -8e-3 -1e-3 -0.011 0 3e-3 1e-3 7e-3 1e-3 0.011m-1e-3 -0.019v-0.011 0.011m0-0.016c-0.018-0.598-0.206-1.152-0.517-1.618l1e-3 -1e-3c0.311 0.466 0.498 1.021 0.516 1.619"
            fill="#94D3E3"
          />
          <path
            d="m253.32 236.56v-8e-3 8e-3m0-0.026v-9e-3 9e-3m0-0.028v-7e-3 7e-3m-1e-3 -0.03v-0.012 0.012m0-0.026c0-4e-3 0-8e-3 -1e-3 -0.012 1e-3 4e-3 1e-3 8e-3 1e-3 0.012m-1e-3 -0.024c0-0.018-1e-3 -0.037-2e-3 -0.055 1e-3 0.018 2e-3 0.037 2e-3 0.055m-2e-3 -0.057c-0.066-1.765-0.932-3.319-2.242-4.327l3e-3 -4e-3c1.31 1.008 2.174 2.566 2.239 4.331"
            fill="#94D3E3"
          />
          <path
            d="m258.01 181.3h-0.019 0.019m-0.024 0h-0.017 0.017m-0.019 0h-0.02 0.02m-0.024 0c-6e-3 0-0.012 0-0.018-1e-3 6e-3 1e-3 0.012 1e-3 0.018 1e-3m-0.02-1e-3h-0.02 0.02m-0.022 0c-7e-3 0-0.013 0-0.02-1e-3 7e-3 1e-3 0.013 1e-3 0.02 1e-3m-0.021-1e-3c-1.513-0.042-2.843-0.817-3.647-1.983 2e-3 0 4e-3 1e-3 6e-3 1e-3 0.803 1.165 2.129 1.94 3.641 1.982"
            fill="#777B78"
          />
          <path
            d="m262.6 176.71v-0.02 0.02m0-0.025v-0.017 0.017m0-0.019v-0.02 0.02m0-0.023c-1e-3 -7e-3 -1e-3 -0.012-1e-3 -0.019 0 6e-3 0 0.013 1e-3 0.019m-1e-3 -0.02v-0.021 0.021m0-0.023c0-7e-3 -1e-3 -0.013-1e-3 -0.02 0 7e-3 1e-3 0.014 1e-3 0.02m-1e-3 -0.02c-0.05-1.798-1.136-3.333-2.681-4.039l3e-3 -3e-3c1.544 0.706 2.628 2.245 2.678 4.042"
            fill="#777B78"
          />
          <path
            d="m235.99 197.91v-8e-3 8e-3m-1e-3 -0.047v-0.02 0.02m0-0.036v-0.035 0.035m-1e-3 -0.047v-0.032 0.032m0-0.039v-0.039 0.039m0-0.048v-0.04 0.04"
            fill="#94D3E3"
          />
          <path d="m266.4 167.5h-9e-3 9e-3" fill="#5A5E5C" />
          <path d="m266.36 167.5h-0.02 0.02" fill="#5A5E5C" />
          <path d="m266.32 167.5h-0.035 0.035" fill="#5A5E5C" />
          <path d="m266.27 167.5h-0.032 0.032" fill="#5A5E5C" />
          <path
            d="m266.23 167.5c-0.013 0-0.026-1e-3 -0.039-1e-3 0.013 0 0.026 1e-3 0.039 1e-3"
            fill="#5A5E5C"
          />
          <path d="m266.18 167.5h-0.04 0.04" fill="#5A5E5C" />
          <path
            d="m255.57 144.22h8e-3c0.018-0.017 0.036-0.034 0.054-0.05-0.018 0.017-0.036 0.033-0.054 0.05h-8e-3m0.067-0.055c0.018-0.017 0.036-0.033 0.053-0.049-0.017 0.016-0.035 0.033-0.053 0.049m0.059-0.054c0.018-0.017 0.036-0.034 0.054-0.05-0.018 0.016-0.036 0.033-0.054 0.05m0.057-0.053c4.377-4.009 9.793-6.85 15.51-8.548 3e-3 5e-3 6e-3 0.011 9e-3 0.017-5.72 1.694-11.141 4.521-15.519 8.531"
            fill="#B4DFE8"
          />
          <path
            d="m273.3 134.96c0.027-6e-3 0.056-0.013 0.083-0.02 0 5e-3 1e-3 0.011 1e-3 0.016-0.028 2e-3 -0.056 3e-3 -0.084 4e-3"
            fill="#E4E4DE"
          />
          <path
            d="m271.27 135.53v-1e-3c0.088-0.026 0.176-0.052 0.264-0.078l1e-3 1e-3c-0.088 0.026-0.176 0.052-0.265 0.078"
            fill="#7ECBDC"
          />
          <path
            d="m271.54 135.45-1e-3 -1e-3c0.613-0.177 1.228-0.342 1.846-0.493v-4e-3c6e-3 0 0.013 0 0.02-1e-3 -0.625 0.153-1.246 0.319-1.865 0.499"
            fill="#C6C7C2"
          />
          <path
            d="m271.27 135.53c-3e-3 -6e-3 -6e-3 -0.012-9e-3 -0.017 0.085-0.026 0.17-0.051 0.255-0.075 7e-3 5e-3 0.012 9e-3 0.018 0.014-0.088 0.026-0.176 0.052-0.264 0.078"
            fill="#A7D9DF"
          />
          <path
            d="m271.54 135.45c-6e-3 -5e-3 -0.011-9e-3 -0.018-0.014 0.591-0.172 1.184-0.331 1.78-0.479 0.028-1e-3 0.056-2e-3 0.084-4e-3v4e-3c-0.618 0.151-1.233 0.316-1.846 0.493"
            fill="#D3D4CE"
          />
          <path
            d="m271.26 135.51c-0.085-0.175-0.175-0.345-0.256-0.523 0.24 7e-3 0.479 0.01 0.719 0.01 0.524 0 1.048-0.015 1.572-0.041-0.596 0.148-1.189 0.307-1.78 0.479-0.085 0.024-0.17 0.049-0.255 0.075"
            fill="#F6C8A7"
          />
          <path
            d="m451.04 114.24c0.337-0.116 0.672-0.242 1.003-0.376-0.331 0.134-0.666 0.26-1.003 0.376"
            fill="#7ECBDC"
          />
          <path
            d="m444.32 115.35c2.283 0 4.565-0.366 6.729-1.112-2.165 0.746-4.446 1.112-6.729 1.112"
            fill="#171A1A"
          />
          <path
            d="m432.85 112.02-0.069-0.045 0.069 0.045m-0.209-0.137c-1.317-0.863-2.632-1.698-3.947-2.519l3e-3 -6e-3c1.315 0.82 2.627 1.662 3.944 2.525"
            fill="#171A1A"
          />
          <path
            d="m186 215.28v1.165c0 5.0972-4.1727 9.2706-9.2756 9.2706h-90.545c-5.0979 0-9.2699 4.1727-9.2699 9.2756v3.9544c0 5.0972-4.1734 9.2706-9.2763 9.2706h-66.683c-0.20251 0-0.4036-0.005725-0.6054-0.0229v-41.359c1.2208-0.5324-1.3332-0.82938 0.11235-0.82938h176.27c5.1029 0 9.2756 4.1727 9.2756 9.2756"
            fill="#FFFFFE"
          />
          <path
            d="m603.21 172.24v0.6334c0 4.189 3.4299 7.6177 7.6189 7.6177h34.746v25.306h-103.89c-4.1842 0-7.6134-3.4244-7.6134-7.614v-10.078c0-4.189 3.4293-7.6141 7.6134-7.6141h16.043c4.189 0 7.6134-3.4287 7.6134-7.6177v-0.6334c0-4.1896-3.4244-7.6183-7.6134-7.6183h-70.111c-3.9744 0-7.2291-2.8829-7.2291-6.4083 0-3.5212-3.2546-6.4041-7.2339-6.4041h-25.964c-2.0972 0-3.9974-0.85581-5.3778-2.2368-1.3804-1.3798-2.2362-3.2848-2.2362-5.3814 0-4.189 3.4244-7.614 7.6141-7.614h198.38v28.045h-34.746c-4.189 0-7.6189 3.4287-7.6189 7.6183"
            fill="#FFFFFE"
          />
          <g transform="translate(513 201)">
            <path
              d="m55.508 0s-54.17 100.72-55.46 137.12c-1.29 36.402 23.389 62.306 84.633 42.469 63.69-20.629-29.173-179.59-29.173-179.59"
              fill="#B6C64F"
            />
            <path
              d="m77.701 34.916s-64.956 74.697-73.164 104.87c-8.206 30.169 7.324 56.074 62.343 50.132 57.217-6.182 10.821-155 10.821-155"
              fill="#8FA93D"
            />
            <polyline
              points="74.68 147.03 55.118 160.18 55.118 130.38 61.392 125.62 75.712 131.14 76.911 128.02 64.517 123.25 74.386 115.76 72.372 113.11 55.118 126.19 55.118 92.615 50.464 92.615 50.464 108.96 39.886 100.67 37.826 103.29 50.464 113.2 50.464 146.53 40.285 141.18 38.795 126.36 35.475 126.69 36.746 139.32 25.979 133.65 24.425 136.6 50.464 150.3 50.464 174.32 33.105 165.18 31.553 168.14 50.464 178.08 50.464 217.53 55.118 217.53 55.118 164.2 76.54 149.8 74.68 147.03"
              fill="#2D1C17"
            />
          </g>
          <g transform="translate(462 251)">
            <polygon points="47 169 59 169 59 135 47 135" fill="#2D1C17" />
            <polygon points="47 169 53 169 53 135 47 135" fill="#442829" />
            <path
              d="m0 82.629c0 30.905 23.794 53.371 52.512 53.371 28.723 0 51.488-22.466 51.488-53.371 0-30.9-23.788-82.629-52.512-82.629-28.726 0-51.488 51.729-51.488 82.629"
              fill="#B6C64F"
            />
            <path
              d="m51.92 0c0.70408 0 1.3885 0.055144 2.0803 0.11597v135.83c-0.3631 0.01703-0.69178 0.051901-1.0467 0.051901-28.959 0-52.953-22.466-52.953-53.371 0-30.9 22.954-82.629 51.92-82.629"
              fill="#8FA93D"
            />
          </g>
          <g transform="translate(267 330.5) scale(-1 1) translate(-183 -83.5)">
            <polygon points="144 31 144 74 244 74 244 31" fill="#4E3736" />
            <polygon
              points="0 31 0 74 148 74 148 31 76.678 31"
              fill="#4E3736"
            />
            <polygon points="6 167 171 167 171 79 6 79" fill="#A2BD8F" />
            <polygon points="6 87 171 87 171 79 6 79" fill="#000" />
            <polyline
              points="321 50 294 44.744 294 0 321 0 321 50"
              fill="#B2B2AE"
            />
            <polygon points="290 18 323 18 323 0 290 0" fill="#A2BD8F" />
            <polyline
              points="321 18 294 18 300.98 26 321 26 321 18"
              fill="#000"
            />
            <polyline
              points="173 86.112 173 165 361 165 361 86.112 267 31 173 86.112"
              fill="#DBE6CE"
            />
            <polygon points="202 125 210 125 210 114 202 114" fill="#6E6E6B" />
            <polygon points="215 125 223 125 223 114 215 114" fill="#6E6E6B" />
            <polygon points="202 109 210 109 210 98 202 98" fill="#6E6E6B" />
            <polygon points="215 109 223 109 223 98 215 98" fill="#6E6E6B" />
            <path
              d="m214.23 125.6h8.3102v-11.896h-8.3102v11.896zm-11.769 0h8.3077v-11.896h-8.3077v11.896zm0-15.295h8.3077v-11.899h-8.3077v11.899zm11.769 0h8.3102v-11.899h-8.3102v11.899zm-15.231 18.698h27v-34h-27v34z"
              fill="#FFFFFE"
            />
            <polygon points="311 125 319 125 319 114 311 114" fill="#6E6E6B" />
            <polygon points="323 125 331 125 331 114 323 114" fill="#6E6E6B" />
            <polygon points="311 109 319 109 319 98 311 98" fill="#6E6E6B" />
            <polygon points="323 109 331 109 331 98 323 98" fill="#6E6E6B" />
            <path
              d="m322.23 125.6h8.3102v-11.896h-8.3102v11.896zm-11.769 0h8.3077v-11.896h-8.3077v11.896zm0-15.295h8.3077v-11.899h-8.3077v11.899zm11.769 0h8.3102v-11.899h-8.3102v11.899zm-15.231 18.698h27v-34h-27v34z"
              fill="#FFFFFE"
            />
            <polyline
              points="267 23 173 78.095 173 86 267 31.034 361 86 361 78.095 267 23"
              fill="#000"
            />
            <polygon points="158 164 361 164 361 149 158 149" fill="#B2B2AE" />
            <polygon points="247 150 287 150 287 88 247 88" fill="#404568" />
            <polyline points="286 149 286 164 301 164 286 149" fill="#82837F" />
            <polygon
              points="165 73.211 165 83 266 23.787 265 14"
              fill="#6B4A49"
            />
            <polyline
              points="265 14 265 23.787 366 83 366 73.211 266 14"
              fill="#4E3736"
            />
            <polygon points="247 157 287 157 287 149 247 149" fill="#E1E1DC" />
            <polygon points="247 165 287 165 287 157 247 157" fill="#D0CFCA" />
            <polygon points="0 82 165 82 165 72 0 72" fill="#886D6A" />
            <polyline
              points="287 85 247 85 247 151 252.35 151 252.35 90.335 287 90.335 287 100.58"
              fill="#2B3048"
            />
            <polygon points="27 167 146 167 146 101 27 101" fill="#21406B" />
            <polygon
              points="27 98 27 167 32.192 167 32.192 103.3 146 103.3 146 98"
              fill="#1C2D4A"
            />
            <polygon points="27 114 146 114 146 109 27 109" fill="#2A598F" />
            <polygon points="27 124 146 124 146 119 27 119" fill="#2A598F" />
            <polygon points="27 135 146 135 146 130 27 130" fill="#2A598F" />
            <polygon points="27 145 146 145 146 140 27 140" fill="#2A598F" />
            <polygon points="27 157 146 157 146 152 27 152" fill="#2A598F" />
            <polygon points="27 166 146 166 146 161 27 161" fill="#2A598F" />
            <polygon points="27 124 32 124 32 119 27 119" fill="#203A5A" />
            <polygon points="27 135 32 135 32 130 27 130" fill="#203A5A" />
            <polygon points="27 145 32 145 32 140 27 140" fill="#203A5A" />
            <polygon points="27 157 32 157 32 152 27 152" fill="#203A5A" />
            <polygon points="27 166 32 166 32 161 27 161" fill="#203A5A" />
            <polygon points="27 114 32 114 32 109 27 109" fill="#203A5A" />
          </g>
        </g>
        <rect
          x="47"
          y="426"
          width="555"
          height="172"
          fill="url(#linearGradient-1)"
        />
        <path
          d="m641.92 631.61c79.925-5.9593 339.98-4.2935 397.11 0 57.132 4.2935 19.846 24.39-196.06 24.39-12.599 0-24.685-0.062761-36.258-0.18214-186.75-1.9264-240.05-18.596-164.79-24.208z"
          fill="#D8D8D8"
          opacity=".16"
        />
        <polygon
          points="0 91 621 91 621 622 0 622 0 122.59"
          fill="#fff"
          style={{ mixBlendMode: "color" }}
        />
        <g transform="translate(621 272)">
          <path
            d="m14 0h396v312h-396c-7.732 0-14-6.268-14-14l1.7764e-15 -284c-9.469e-16 -7.732 6.268-14 14-14z"
            fill="#F3F1F1"
          />
          <rect x="170" y="312" width="330" height="13" fill="#D9D9D9" />
          <path
            d="m0 257h410v56h-396c-7.732 0-14-6.268-14-14v-42z"
            fill="#EFEFEF"
          />
          <path
            d="m0 257h410v56h-396c-7.732 0-14-6.268-14-14v-42z"
            fill="url(#pattern-2)"
            fillOpacity=".0032835"
          />
          <g transform="translate(47 251)">
            <path
              d="m123.18 61.644c2.7079-30.711-25.026-61.644-61.184-61.644-36.1-3.4532e-14 -62.331 33.172-61.184 61.644 0.02047 0.50813 32.759-0.21457 62.514 0 19.265 0.13893 39.217 0.13893 59.855 0z"
              fill="#D9D9D9"
            />
            <ellipse
              cx="62.408"
              cy="62.055"
              rx="57.513"
              ry="57.945"
              fill="#E3E3E3"
            />
            <ellipse
              cx="62.408"
              cy="62.877"
              rx="34.671"
              ry="34.932"
              fill="#EFEFEF"
            />
          </g>
          <path
            d="m0 200h13c4.4183 0 8 3.5817 8 8v40c0 4.4183-3.5817 8-8 8h-13v-56z"
            fill="#D9D9D9"
          />
          <path
            d="m0 208h0.5c5.2467 0 9.5 4.2533 9.5 9.5s-4.2533 9.5-9.5 9.5h-0.5v-19z"
            fill="#F9F9F9"
          />
          <path
            d="m0 233h0.5c5.2467 0 9.5 4.2533 9.5 9.5s-4.2533 9.5-9.5 9.5h-0.5v-19z"
            fill="#E1E1E1"
          />
        </g>
        <rect
          transform="translate(907 317) rotate(180) translate(-907 -317)"
          x="621"
          y="191"
          width="572"
          height="252"
          fill="url(#linearGradient-1)"
        />
        <rect
          transform="translate(877.5 341.57) rotate(-90) translate(-877.5 -341.57)"
          x="536.5"
          y="-16.932"
          width="682"
          height="717"
          fill="url(#linearGradient-1)"
        />
        <path
          d="m204.75 642.44c30.242-2.9892 128.64-2.1536 150.26 0 21.617 2.1536 7.5094 12.234-74.185 12.234-4.7672 0-9.3401-0.031481-13.719-0.091362-70.662-0.96628-90.829-9.3277-62.352-12.142z"
          fill="#D8D8D8"
          opacity=".16"
        />
        <g transform="translate(224 356)">
          <polygon
            points="23.486 80.095 47.269 80.095 47.269 71.592 23.486 71.592"
            fill="#C83739"
          />
          <polygon
            points="23.486 91.783 47.269 91.783 47.269 83.28 23.486 83.28"
            fill="#DF9F52"
          />
          <polygon
            points="37.422 112.66 46.103 112.66 46.103 106.04 37.422 106.04"
            fill="#908D9A"
          />
          <polygon
            points="51.359 112.66 60.039 112.66 60.039 106.04 51.359 106.04"
            fill="#908D9A"
          />
          <path
            d="m119.5 87.032c-0.087996 0.069147-1.186 0.72196-2.3786 1.4254-2.0583 1.2147-3.7969 2.9004-5.0721 4.9171l-2.4426 3.8619s5.6815 4.7309 5.9739 4.5795c4.8272-2.4936 8.2869-6.8368 8.2869-6.8368l-4.3676-7.947"
            fill="#FEC398"
          />
          <path
            d="m115.7 101.14s-25.843 21.84-25.887 21.878c-4.1326 3.3581-10.983 4.1667-15.312 1.015-0.6492-0.47227-19.491-35.183-19.491-35.183h15.306s9.0435 20.994 9.5021 21.849c0.7856 1.4631 2.2381 2.7444 3.0292 2.8649 1.381 0.22806 1.8609-0.33334 3.3031-0.64341 5.0126-1.0776 23.921-16.839 23.921-16.839 3.7523 3.3728 5.6284 5.0592 5.6284 5.0592z"
            fill="#FEC398"
          />
          <path
            d="m65.972 97.965c-5.2138-8.0413-7.8207-12.062-7.8207-12.062l7.8207-17.852s2.8912 7.1875 8.6735 21.562l-8.6735 8.352z"
            fill="#3A6EBF"
          />
          <path
            transform="translate(81.119 271.49) rotate(-10) translate(-81.119 -271.49)"
            d="m76.187 279.63 9.8659 0.18294-0.21862-16.656-9.2084 2.2535c-0.06996 0.93104-0.43889 14.22-0.43889 14.22z"
            fill="#A3BCE3"
          />
          <path
            transform="translate(71.262 209.63) rotate(-9) translate(-71.262 -209.63)"
            d="m62.284 148.43c-4.327 9.9987 3.2056 124.63 3.2056 124.63l12.726-0.53735 3.3657-123.29-19.322-3.0264c-0.016943 0.13994 0.21964 1.7814 0.025688 2.2296z"
            fill="#2C2C2C"
          />
          <path
            transform="translate(14.63 268.12) rotate(22) translate(-14.63 -268.12)"
            d="m9.8833 265.1c-0.054109 0.47604-0.18747 7.2647-0.18747 7.2647l9.8676 0.004195-0.51377-8.5029-9.1663 1.234"
            fill="#A3BCE3"
          />
          <path
            transform="translate(31.931 209.96) rotate(6) translate(-31.931 -209.96)"
            d="m24.493 154.07c0.35236 9.0649 1.4539 36.924 2.5307 64.117-7.1969 31.905-10.795 47.857-10.795 47.857l10.693 2.046 17.851-48.147 2.8618-65.128-23.198-2.9939c-0.014757 0.14138 0.0054656 0.91861 0.057389 2.2489z"
            fill="#2C2C2C"
          />
          <polyline
            transform="translate(15.768 265.93) rotate(19) translate(-15.768 -265.93)"
            points="8.936 264.2 22.6 264 22.331 267.47 9.206 267.87 8.936 264.2"
            fill="#656565"
          />
          <polyline
            transform="translate(81.635 271.36) rotate(-8) translate(-81.635 -271.36)"
            points="88.461 269.51 74.81 270.09 75.271 273.2 88.395 272.83 88.461 269.51"
            fill="#656565"
          />
          <path
            transform="translate(21.005 280.8) rotate(23) translate(-21.005 -280.8)"
            d="m37.169 286.79c1.072 0.009467-6.3254-3.9901-22.192-11.999h-10.163l-0.074332 11.76 32.43 0.23881z"
            fill="#2C2C2C"
          />
          <path
            d="m109.43 290.22c1.072 0.009467-6.3254-3.9901-22.192-11.999h-10.163l-0.074332 11.76 32.43 0.23881z"
            fill="#2C2C2C"
          />
          <path
            d="m70.202 152.73c-1.8895 3.1223-2.6376 8.9617-6.2706 9.3529l-19.663 2.1181c-0.58482 0.063372-1.1609 0.076168-1.7293 0.039607-1.4631-0.07373-5.2033-4.1059-6.4893-4.7445-0.22901-0.10846-0.4531-0.23094-0.67227-0.36134-3.4045-1.9779-5.875-5.779-6.2712-10.356l-0.24267-6.9946 42.319-4.9722 0.98053 7.3279c0.27328 3.1552-0.4837 6.1555-1.9616 8.5899z"
            fill="#2C2C2C"
          />
          <path
            d="m45.617 72.706c-2.84 0.56657-5.5758-7.335-6.0788-10.527l-3.107-19.686c-0.50358-3.1921 1.408-6.2665 4.2475-6.8325l1.6283-0.32446c2.8395-0.56657 5.5753 1.582 6.0783 4.7735l3.1065 19.686c0.50407 3.1921-1.4075 12.02-4.247 12.586l-1.6278 0.32446z"
            fill="#FEC398"
          />
          <path
            d="m63.366 18.672c0.029507 0.30079 0.053604 0.60211 0.072291 0.90395 0.080159 1.4548 0.019671 2.8949-0.17999 4.2885-0.84733 5.9641-4.1545 11.182-8.8967 14.284-2.3546 1.5432-5.0638 2.5612-7.9997 2.8918-4.7525 0.53463-8.4851 3.2439-12.118 0.55032-1.1709-0.86681-2.2499-1.8623-3.2064-2.9828-0.3767-0.44151-0.73619-0.89139-1.075-1.3617-2.064-2.8698-4.245-10.441-4.6281-14.294-1.0804-10.866 6.0892-20.637 16.14-22.259 0.2872-0.044465 0.57489-0.083176 0.86307-0.11561 6.4024-0.72033 12.395 2.0051 16.357 6.7765l0.0068848 0.0057543c1.1596 1.402 2.1451 2.9844 2.9167 4.7028 0.90733 2.026 1.5137 4.2529 1.7483 6.6091"
            fill="#060606"
          />
          <path
            d="m39.958 30.651c0.056296 0.45789 0.028968 0.91143-0.084717 1.3426-0.12407 0.51506-0.35308 1.0808-0.68429 1.5054-0.60012 0.76334-1.4741 1.3797-2.5174 1.5071l-2.2425 0.27604-1.7195 0.21561-0.64494-5.0831 0.0065587-0.001089-0.12352-0.93975-0.091822-0.72958-0.080891-0.6686-0.024049-0.1726 0.0054656-0.0010889 3.9565-0.49056c0.99911-0.12577 1.9556 0.14755 2.712 0.69038 0.45911 0.32995 0.8417 0.76824 1.115 1.2702 0.2219 0.39038 0.36073 0.81506 0.41812 1.2789"
            fill="#F3BEB4"
          />
          <path
            d="m62.909 20.879 0.92847 7.898 0.14016 1.1822c0.094913 0.77788 0.12885 1.5615 0.11852 2.3226-0.10917 7.1521-4.6168 13.476-11.088 15.596-0.19327 0.072713-0.3949 0.12921-0.59259 0.17838-0.69635 0.21029-1.4094 0.35101-2.1461 0.45354-0.71455 0.098346-1.4168 0.1334-2.12 0.12659-1.3721-0.0083699-2.7136-0.21082-3.9922-0.58328l-0.011803-0.0036619c-5.5694-1.6164-10.022-6.4014-11.248-12.591-0.037375-0.18728-0.073275-0.3688-0.098847-0.55817-0.047702-0.21605-0.074258-0.44203-0.09983-0.66802l-0.019671-0.1177-0.06639-0.5341-0.16081-1.4093-0.57784-4.8357-0.0024589-0.048127-9.836e-4 -0.0062774-0.10426-0.89767-0.082618-0.70098-0.072783-0.64239-0.01672-0.16687c-0.12294-1.1189-0.09147-2.2306 0.041801-3.3124 0.085077-0.75748 0.22327-1.5066 0.39342-2.2311 0.020163-0.11927 0.043276-0.22076 0.070816-0.32904 0.14016-0.59792 0.32015-1.1969 0.52718-1.7702l0.0034424-0.012555c0.7834-2.1892 1.9976-4.186 3.5487-5.8453 0.31031-0.33166 0.63341-0.6539 0.96536-0.9594 2.3163-2.1019 5.2059-3.5399 8.4354-3.9673 4.3188-0.57177 8.4964 0.74806 11.691 3.3647 1.7124 1.3962 2.9792 3.1743 4.0262 5.2061 0.40326 0.77421 0.71652 1.5903 0.95503 2.4383 0.31277 1.0886 0.52079 2.2342 0.65652 3.4238"
            fill="#FECDA9"
          />
          <path
            d="m44.157 48.053c-5.5812-1.6201-13.871-5.559-13.668-17.35-0.77794-0.45271-1.4989-0.37618-2.1254-1.6714-0.46668-0.96484-0.62406-2.5028 0-3.3497 0.55915-0.75538 1.5521-0.99985 2.5027-1.1908l0.90018 1.8918-0.082618-0.70098-0.072783-0.64239-0.021638-0.16583c-0.11803-1.12-0.086553-2.2316 0.046719-3.3134 1.8855-1.6379 3.978-2.2756 5.6549 0.28144 0 0 0.08852 1.2832 0.30343 3.2229 0.15688 1.4527 0.37965 3.2695 0.6875 5.1857 0.62308 3.9406 1.5781 8.2982 2.9752 10.787 2.9762 5.3128 8.5761 7.4937 8.5761 7.4937s-2.7353 0.71876-5.6761-0.47813z"
            fill="#FEC398"
          />
          <path
            d="m28.57 151.49-5.6274-58.824 11.924-31.618 0.61488-9.2072 6.3062-0.59238 6.5379 9.1435 2.4288-8.842 3.8889 2.3826c9.0167 45.111 14.388 72.187 16.114 81.226 0.9652 5.056 1.5435 8.2325 1.7348 9.5297 0.70446 4.7757-13.936 7.0431-43.922 6.8022z"
            fill="#4075C6"
          />
          <path
            d="m38.5 149.05c-1.2319 0.21561-2.6344 0.42087-4.1708 0.5853-2.1545 0.22595-14.812-61.64-12.728-76.515-0.020769-1.0426-0.041538-2.1419-0.08253-3.3022-0.025688-0.69365 0.051377-1.3405 0.20605-1.9568 0.81437-3.2303 3.8817-5.4849 7.2381-7.1641 2.0212-1.0067 4.1451-2.902 5.9389-3.575 0.83569-0.31797 0.66188-0.17641 1.0926-0.57005l10.915 91.162s-4.883 0.70889-8.4094 1.3356z"
            fill="#4075C6"
          />
          <path
            d="m63.234 145.37s-9.0816-87.841-8.2803-87.542c1.3603 0.50998 2.8266 1.3008 4.2673 2.3338 2.9569 2.1096 5.8085 5.2397 7.4046 9.0485 0.4596 1.0831 0.81326 2.2277 1.0311 3.4169 1.3848 7.6416 4.8584 72.743 4.8584 72.743h-9.281z"
            fill="#4075C6"
          />
          <path
            d="m52.33 75.345c0.050283 0.56515-0.36893 1.0633-0.93626 1.1134-0.56733 0.050091-1.0674-0.36751-1.1177-0.93267-0.049737-0.56515 0.36893-1.0639 0.93626-1.1134 0.56733-0.050091 1.0674 0.36751 1.1177 0.93267"
            fill="#2E548E"
          />
          <path
            d="m54.338 90.017c0.050283 0.56515-0.36947 1.0639-0.93626 1.1134-0.56733 0.050091-1.068-0.36751-1.1183-0.93267-0.050283-0.56515 0.36947-1.0633 0.9368-1.1134 0.56678-0.050091 1.0674 0.36751 1.1177 0.93267"
            fill="#2E548E"
          />
          <path
            d="m55.8 104.15c0.050283 0.56461-0.36893 1.0633-0.93626 1.1134-0.56678 0.049546-1.0674-0.36806-1.1177-0.93267-0.050283-0.56515 0.36893-1.0639 0.93626-1.114 0.56733-0.049546 1.068 0.36751 1.1177 0.93321"
            fill="#2E548E"
          />
          <path
            d="m57.262 117.73c0.049737 0.56461-0.36893 1.0633-0.93626 1.1134-0.56733 0.050091-1.068-0.36751-1.1177-0.93267-0.050283-0.56515 0.36893-1.0639 0.93626-1.1134 0.56678-0.050091 1.0674 0.36751 1.1177 0.93267"
            fill="#2E548E"
          />
          <path
            d="m58.723 130.77c0.049737 0.56515-0.36893 1.0633-0.9368 1.1134-0.56678 0.050091-1.0674-0.36751-1.1172-0.93267-0.050283-0.56515 0.36893-1.0639 0.93571-1.1134 0.56787-0.05009 1.0685 0.36751 1.1183 0.93267"
            fill="#2E548E"
          />
          <polygon
            points="41.53 56.966 33.706 57.742 35.17 51.66 41.926 51.157"
            fill="#84A6DA"
          />
          <polygon
            points="51.818 57.09 55.367 57.09 54.908 51.452 50.695 51.452"
            fill="#84A6DA"
          />
          <path
            d="m31.373 28.863c0.16376 0.84536 1.0244 1.3078 1.761 0.94632 0.35605-0.17524 0.61521-0.51423 0.70029-0.92226 0.38211-1.8199 2.0888-5.9716 3.3531-8.7949 1.5461-3.4541-1.174-14.64 20.439-5.7942 1.6234 0.66439 7.5134-9.3161-7.2966-12.792-8.2319-1.9318-19.018 9.3753-19.792 11.842-0.77307 2.467 0.61865 12.665 0.61865 12.665l0.21569 2.8496z"
            fill="#060606"
          />
          <path
            d="m36.314 145.98-0.61488-0.25753c0.074332 0.009256 0.14757 0.025045 0.21808 0.047368 0.1432 0.044646 0.27711 0.11434 0.3968 0.21016"
            fill="#B89C8E"
          />
          <path
            d="m9.1949 90.293c-4.7383 8.0332-8.9167 27.501-8.5554 33.661 0.75237 12.802 38.173 32.797 38.584 33.351l3.4667-10.074c-0.077524-0.10812-29.785-14.215-30.359-23.966-0.43646-7.4312 7.1213-28.026 10.907-32.972 0.54034-0.70199-12.496-2.6238-14.043 0z"
            fill="#FEC398"
          />
          <path
            d="m20.392 69.669c-1.5628 2.6488-3.9757 5.626-6.1575 9.3256-4.4541 7.5514-7.392 12.61-8.8138 15.176l16.024 2.6957c1.4066-5.2984 3.6797-9.7024 6.8192-13.212 8.9304-9.9831 1.9095-30.563-7.8715-13.985z"
            fill="#3A6EBF"
          />
        </g>
        <g transform="translate(300.97 468.78) rotate(-3) translate(-53.5 -40.5)">
          <polygon
            points="5.6843e-14 1 94 1 97.748 39.886 94 80 5.6843e-14 80"
            fill="#F8AB08"
          />
          <polygon
            points="93.974 0.99193 106.56 1.7198 106.78 77.727 93.983 80.008"
            fill="#E79A15"
          />
          <rect x="38.706" y="1" width="17.51" height="15.616" fill="#FB3C3E" />
          <rect
            x="5.5294"
            y="60.709"
            width="22.118"
            height="2.7558"
            fill="#FB3C3E"
          />
          <rect
            x="5.5294"
            y="66.221"
            width="22.118"
            height="2.7558"
            fill="#FB3C3E"
          />
          <rect
            x="5.5294"
            y="71.733"
            width="22.118"
            height="2.7558"
            fill="#FB3C3E"
          />
          <rect
            x="38.706"
            y="16.616"
            width="1"
            height="1.8372"
            fill="#FF383C"
          />
          <rect
            x="40.549"
            y="16.616"
            width="1"
            height="1.8372"
            fill="#FF383C"
          />
          <rect
            x="42.392"
            y="16.616"
            width="1"
            height="1.8372"
            fill="#FF383C"
          />
          <rect
            x="44.235"
            y="16.616"
            width="1"
            height="1.8372"
            fill="#FF383C"
          />
          <rect
            x="46.078"
            y="16.616"
            width="1"
            height="1.8372"
            fill="#FF383C"
          />
          <rect
            x="47.922"
            y="16.616"
            width="1"
            height="1.8372"
            fill="#FF383C"
          />
          <rect
            x="49.765"
            y="16.616"
            width="1"
            height="1.8372"
            fill="#FF383C"
          />
          <rect
            x="51.608"
            y="16.616"
            width="1"
            height="1.8372"
            fill="#FF383C"
          />
          <rect
            x="53.451"
            y="16.616"
            width="1"
            height="1.8372"
            fill="#FF383C"
          />
          <rect
            x="55.294"
            y="16.616"
            width="1"
            height="1.8372"
            fill="#FF383C"
          />
          <path
            d="m71.882 69.895c0-3.044-2.4756-5.5116-5.5294-5.5116s-5.5294 2.4676-5.5294 5.5116"
            fill="#FB3C3E"
          />
          <polyline
            points="66.451 69.557 66.451 72.204 66.451 74.85 65.698 74.85 64.712 74.85 64.319 74.606 64.007 73.574 64.007 72.204"
            stroke="#FB3C3E"
          />
          <path
            d="m82.941 73.57v-6.4302h-0.92157l2.3039-2.2965 2.3039 2.2965h-0.92157v6.4302h1.8431v1.8372h-12.902v-1.8372h1.8431v-6.4302h-0.92157l2.3039-2.2965 2.3039 2.2965h-0.92157v6.4302h3.6863z"
            fill="#FB3C3E"
          />
        </g>
        <g transform="translate(248 482)" fill="#000" opacity=".049932">
          <path
            transform="translate(17.808 20.753) rotate(-36) translate(-17.808 -20.753)"
            d="m25.63 28.72c-1.5635-2.2913-2.7499-9.9609-4.9386-11.831l-4.2117-5.318s-5.3079 5.4377-5.5951 5.7116c-3.9956 3.8077 5.1817 9.9055 5.1817 9.9055s3.8121 4.6307 5.0323 1.8692c0.054734-0.1238 5.4696 1.039 4.5314-0.33696z"
          />
          <path d="m12.224 25.305 3.4667-10.074c-0.025911-0.036136-5.2269-5.0635-15.603-15.082l1.0967 22.984c7.2213 1.262 10.901 1.9861 11.04 2.1722z" />
        </g>
        <path
          d="m259.23 507.01c-1.5495-0.35301-4.8969-0.97912-10.042-1.8783l-1.0376-22.907c10.337 9.9676 15.518 14.969 15.544 15.006l-0.028889 0.083947 2.2076 0.61727c2.8702 0.22678 8.338 5.7342 10.95 6.6689 1.5678 0.5617-3.4964 2.8038-3.4679 2.9361 0.63597 2.9513-5.1699 1.4457-5.1699 1.4457s-6.3269 0.265-8.9546-1.9722z"
          fill="#000"
          opacity="0"
        />
        <g transform="translate(224 474)" fill="#FEC398">
          <path
            transform="translate(45.173 34.488) rotate(-36) translate(-45.173 -34.488)"
            d="m53.461 35.411c-1.5635-2.2913-3.6872-4.6525-5.8759-6.5231l-4.1914-3.5819s-5.3079 5.4377-5.5951 5.7116c-3.9956 3.8077 5.1817 9.9055 5.1817 9.9055s3.8121 4.6307 5.0323 1.8692c0.054734-0.1238 6.3865-6.0054 5.4483-7.3813z"
          />
          <path d="m0.63951 5.954c0.75237 12.802 38.173 32.797 38.584 33.351l3.4667-10.074c-0.077524-0.10812-29.785-14.215-30.359-23.966-0.43646-7.4312-12.053-5.4709-11.692 0.68912z" />
        </g>
        <path
          d="m405.77 644.19c43.131-3.374 183.47-2.4309 214.3 0s10.71 13.809-105.8 13.809c-6.7991 0-13.321-0.035534-19.566-0.10312-100.78-1.0907-129.54-10.529-88.928-13.706z"
          fill="#D8D8D8"
          opacity=".16"
        />
        <g transform="translate(408 490)">
          <g transform="translate(0 79)">
            <rect width="94" height="79" fill="#F8AB08" />
            <rect x="38.706" width="17.51" height="15.616" fill="#FB3C3E" />
            <rect
              x="5.5294"
              y="59.709"
              width="22.118"
              height="2.7558"
              fill="#FB3C3E"
            />
            <rect
              x="5.5294"
              y="65.221"
              width="22.118"
              height="2.7558"
              fill="#FB3C3E"
            />
            <rect
              x="5.5294"
              y="70.733"
              width="22.118"
              height="2.7558"
              fill="#FB3C3E"
            />
            <rect
              x="38.706"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="40.549"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="42.392"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="44.235"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="46.078"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="47.922"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="49.765"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="51.608"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="53.451"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="55.294"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <path
              d="m71.882 68.895c0-3.044-2.4756-5.5116-5.5294-5.5116s-5.5294 2.4676-5.5294 5.5116"
              fill="#FB3C3E"
            />
            <polyline
              points="66.451 68.557 66.451 71.204 66.451 73.85 65.698 73.85 64.712 73.85 64.319 73.606 64.007 72.574 64.007 71.204"
              stroke="#FB3C3E"
            />
            <path
              d="m82.941 72.57v-6.4302h-0.92157l2.3039-2.2965 2.3039 2.2965h-0.92157v6.4302h1.8431v1.8372h-12.902v-1.8372h1.8431v-6.4302h-0.92157l2.3039-2.2965 2.3039 2.2965h-0.92157v6.4302h3.6863z"
              fill="#FB3C3E"
            />
          </g>
          <rect
            x="6"
            y="79"
            width="88"
            height="18"
            fill="url(#linearGradient-4)"
            opacity=".20992"
          />
          <g transform="translate(110 79)">
            <rect width="94" height="79" fill="#F8AB08" />
            <rect x="38.706" width="17.51" height="15.616" fill="#FB3C3E" />
            <rect
              x="5.5294"
              y="59.709"
              width="22.118"
              height="2.7558"
              fill="#FB3C3E"
            />
            <rect
              x="5.5294"
              y="65.221"
              width="22.118"
              height="2.7558"
              fill="#FB3C3E"
            />
            <rect
              x="5.5294"
              y="70.733"
              width="22.118"
              height="2.7558"
              fill="#FB3C3E"
            />
            <rect
              x="38.706"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="40.549"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="42.392"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="44.235"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="46.078"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="47.922"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="49.765"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="51.608"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="53.451"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="55.294"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <path
              d="m71.882 68.895c0-3.044-2.4756-5.5116-5.5294-5.5116s-5.5294 2.4676-5.5294 5.5116"
              fill="#FB3C3E"
            />
            <polyline
              points="66.451 68.557 66.451 71.204 66.451 73.85 65.698 73.85 64.712 73.85 64.319 73.606 64.007 72.574 64.007 71.204"
              stroke="#FB3C3E"
            />
            <path
              d="m82.941 72.57v-6.4302h-0.92157l2.3039-2.2965 2.3039 2.2965h-0.92157v6.4302h1.8431v1.8372h-12.902v-1.8372h1.8431v-6.4302h-0.92157l2.3039-2.2965 2.3039 2.2965h-0.92157v6.4302h3.6863z"
              fill="#FB3C3E"
            />
          </g>
          <g transform="translate(6)">
            <rect width="94" height="79" fill="#F8AB08" />
            <rect x="38.706" width="17.51" height="15.616" fill="#FB3C3E" />
            <rect
              x="5.5294"
              y="59.709"
              width="22.118"
              height="2.7558"
              fill="#FB3C3E"
            />
            <rect
              x="5.5294"
              y="65.221"
              width="22.118"
              height="2.7558"
              fill="#FB3C3E"
            />
            <rect
              x="5.5294"
              y="70.733"
              width="22.118"
              height="2.7558"
              fill="#FB3C3E"
            />
            <rect
              x="38.706"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="40.549"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="42.392"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="44.235"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="46.078"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="47.922"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="49.765"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="51.608"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="53.451"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <rect
              x="55.294"
              y="15.616"
              width="1"
              height="1.8372"
              fill="#FB3C3E"
            />
            <path
              d="m71.882 68.895c0-3.044-2.4756-5.5116-5.5294-5.5116s-5.5294 2.4676-5.5294 5.5116"
              fill="#FB3C3E"
            />
            <polyline
              points="66.451 68.557 66.451 71.204 66.451 73.85 65.698 73.85 64.712 73.85 64.319 73.606 64.007 72.574 64.007 71.204"
              stroke="#FB3C3E"
            />
            <path
              d="m82.941 72.57v-6.4302h-0.92157l2.3039-2.2965 2.3039 2.2965h-0.92157v6.4302h1.8431v1.8372h-12.902v-1.8372h1.8431v-6.4302h-0.92157l2.3039-2.2965 2.3039 2.2965h-0.92157v6.4302h3.6863z"
              fill="#FB3C3E"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
